import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MultiSelect from '../MultiSelect';
import DataGridApi from '../../../data/actions/grid';
import placeholders from '../../../data/placeholders';

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1
    }
  };
};
/**
 * @extends {React.Component<import('../types').FormInputDataSelectProps & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */


var DataSelectFormInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DataSelectFormInput, _React$Component);

  function DataSelectFormInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataSelectFormInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataSelectFormInput)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.loadInitialData = function (ids) {
      var _this$props = _this.props,
          dataType = _this$props.dataType,
          icon = _this$props.icon,
          optionLabel = _this$props.optionLabel,
          dataProps = _this$props.dataProps;
      return DataGridApi().load({
        id: 'select-initial-' + dataType,
        dataType: dataType,
        page: 0,
        itemsPerPage: ids.length,
        dataProps: _objectSpread({
          ids: ids
        }, dataProps)
      }).then(function (data) {
        var hasValues = data.payload && data.payload.Data && data.payload.Data.length > 0;

        if (hasValues) {
          return data.payload.Data.map(function (item) {
            return {
              icon: icon ? placeholders('{icon}', {
                dataType: dataType
              }, item) : undefined,
              item: item,
              label: placeholders(optionLabel, {
                dataType: dataType
              }, item),
              value: item[data.view.idKeyProp]
            };
          });
        }

        return [];
      });
    };

    _this.loadData = function (inputValue) {
      var _this$props2 = _this.props,
          dataType = _this$props2.dataType,
          icon = _this$props2.icon,
          optionLabel = _this$props2.optionLabel,
          dataProps = _this$props2.dataProps,
          itemsPerPage = _this$props2.itemsPerPage,
          onEmptySet = _this$props2.onEmptySet;
      return DataGridApi().load({
        id: 'select-' + dataType,
        dataType: dataType,
        filter: inputValue,
        page: 0,
        itemsPerPage: itemsPerPage,
        dataProps: dataProps
      }).then(function (data) {
        var hasValues = data.payload && data.payload.Data && data.payload.Data.length > 0;

        if (hasValues) {
          return data.payload.Data.map(function (item) {
            return {
              icon: icon ? placeholders('{icon}', {
                dataType: dataType
              }, item) : undefined,
              item: item,
              label: placeholders(optionLabel, {
                dataType: dataType
              }, item),
              value: item[data.view.idKeyProp]
            };
          });
        }

        if (onEmptySet) onEmptySet();
        return [];
      });
    };

    return _this;
  }

  _createClass(DataSelectFormInput, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          classes = _this$props3.classes,
          theme = _this$props3.theme,
          id = _this$props3.id,
          onChange = _this$props3.onChange,
          style = _this$props3.style,
          rest = _objectWithoutProperties(_this$props3, ["classes", "theme", "id", "onChange", "style"]);

      return React.createElement("div", {
        className: classes.root,
        style: style
      }, React.createElement(MultiSelect, Object.assign({
        onChange: onChange,
        onLoad: this.loadData,
        onInitialLoad: this.loadInitialData
      }, rest)));
    }
  }]);

  return DataSelectFormInput;
}(React.Component);

DataSelectFormInput.defaultProps = {
  icon: false,
  optionLabel: '{label}',
  multi: false,
  dataProps: {},
  itemsPerPage: 20
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECDataSelectFormInput'
})(DataSelectFormInput);